
export const common = {
  // Navigation
  home: 'Home',
  curriculum: 'Curriculum',
  projects: 'Projects',
  about: 'About',
  contact: 'Contact',
  consultation: 'Consultation',
  
  // Common buttons
  learnMore: 'Learn More',
  getStarted: 'Get Started',
  apply: 'Apply',
  submit: 'Submit',
  cancel: 'Cancel',
  close: 'Close',
  
  // Company info
  companyName: 'ICAN',
  companyDescription: 'An innovative educational institution that prepares for the future with cosmic thinking. We provide a curriculum designed to turn exploratory learning into real competencies.',
  
  // Contact info
  address: '11F and 16F Strata 100 Building\nEmerald Ave., Ortigas Center\nPasig City, Philippines',
  phone: '+632 5310 5375',
  email: 'teachers.ican@gmail.com',
  businessHours: 'Weekdays: 09:00 - 21:00\nWeekends: 10:00 - 18:00',
  
  // Footer
  programs: 'Programs',
  support: 'Support',
  contactInfo: 'Get in Touch',
  copyright: '© 2024 ICAN Space Education. All rights reserved.',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  educationPolicy: 'Education Policy',
  poweredBy: 'Powered by Readdy',
  certifications: 'Certifications:',
  safeEnvironment: 'Safe Learning Environment',
  professionalConsultants: 'Professional Consultants',
  certifiedProgram: 'Ministry Certified Program',
  internationalStandard: 'International Standard Curriculum',
  
  // Consultation Form
  consultationTitle: 'Consultation',
  consultationHighlight: 'Application',
  consultationDescription: 'ICAN\'s professional consultants will propose an optimized learning plan for your child',
  parentName: 'Parent Name',
  parentNameRequired: 'Parent Name *',
  parentNamePlaceholder: 'Please enter your name',
  phone: 'Phone Number',
  phoneRequired: 'Phone Number *',
  phonePlaceholder: '010-0000-0000',
  studentName: 'Student Name',
  studentNameRequired: 'Student Name *',
  studentNamePlaceholder: 'Please enter student name',
  studentAge: 'Student Age',
  studentAgeRequired: 'Student Age *',
  studentAgePlaceholder: 'Please select age',
  age8to10: '8-10 years old',
  age11to13: '11-13 years old',
  age14to16: '14-16 years old',
  age17to19: '17-19 years old',
  email: 'Email',
  emailPlaceholder: 'example@email.com',
  interests: 'Areas of Interest (Multiple selection possible)',
  dataAnalysis: 'Data Analysis',
  robotics: 'Robotics',
  programming: 'Programming',
  spaceScience: 'Space Science',
  environmentalEngineering: 'Environmental Engineering',
  design: 'Design',
  consultationType: 'Consultation Type',
  consultationTypeRequired: 'Consultation Type *',
  onlineConsultation: 'Online Consultation',
  visitConsultation: 'Visit Consultation',
  phoneConsultation: 'Phone Consultation',
  preferredTime: 'Preferred Consultation Time',
  preferredTimePlaceholder: 'Please select time',
  weekdayMorning: 'Weekday Morning (09:00-12:00)',
  weekdayAfternoon: 'Weekday Afternoon (13:00-17:00)',
  weekdayEvening: 'Weekday Evening (18:00-21:00)',
  weekendMorning: 'Weekend Morning (09:00-12:00)',
  weekendAfternoon: 'Weekend Afternoon (13:00-17:00)',
  additionalMessage: 'Additional Inquiries',
  messagePlaceholder: 'Please write any questions or specific consultation topics (Maximum 500 characters)',
  characterCount: '0/500 characters',
  privacyAgreement: 'I agree to the collection and use of personal information. The collected information will be used only for consultation purposes and will be safely disposed of after consultation completion. *',
  submitConsultation: 'Apply for Consultation',
  phoneConsultationLabel: 'Phone Consultation',
  emailInquiry: 'Email Inquiry',
  consultationHours: 'Consultation Hours',
  consultationHoursTime: 'Weekdays 09:00-21:00'
};
